export default __webpack_public_path__ + "static/DJI_0888-min-442334349ced9e566ab929f8ddf57d6d.jpg";